import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
export function TomosGrid() {
  const tomos = [{
    num: 1,
    title: 'PLANIFICACIÓN RELÁMPAGO',
    desc: '23 prompts listos + planificaciones anuales, trimestrales y de emergencia. Copiás, pegás y entrás al aula. Para primaria y secundaria.',
    color: '📘'
  }, {
    num: 2,
    title: 'EL LABORATORIO CURRICULAR',
    desc: '+25 secuencias didácticas completas por área y nivel. Lengua, Matemática, Ciencias. La clase de mañana resuelta en 5 minutos.',
    color: '📗'
  }, {
    num: 3,
    title: 'INFORMES SIN DESVELO',
    desc: '15 prompts + 130 frases + 6 modelos completos. 30 informes trimestrales en 75 minutos. Sin noches en blanco.',
    color: '📙'
  }, {
    num: 4,
    title: 'ESCENARIOS Y GLOSAS',
    desc: '14 glosas + 8 poemas + 6 obras de teatro. Todo el calendario escolar argentino cubierto. Actos resueltos en 15 minutos.',
    color: '📕'
  }, {
    num: 5,
    title: 'EVALUACIÓN INTELIGENTE',
    desc: '16 rúbricas + 7 exámenes completos + 80 frases de feedback. Evaluá con criterio. Corregí en la mitad del tiempo.',
    color: '📓'
  }, {
    num: 6,
    title: 'EL AULA VISUAL',
    desc: 'Guía de Canva + fichas + carteles + diplomas + portadas. Material visual profesional sin saber diseño.',
    color: '📔'
  }];
  const features = ['100% listo — abrís el PDF y arrancás', 'Primaria y Secundaria incluidos', 'Contexto educativo argentino', 'Formato copiar, pegar e imprimir', 'Sin necesidad de usar IA (aunque podés)'];
  return <section className="py-14 px-6 max-w-7xl mx-auto" data-id="element-247">
      <div className="text-center mb-10" data-id="element-248">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-249">
          🏆 BIBLIOTECAS DIGITALES™ MEGAPACK DOCENTE
        </h2>
        <p className="text-xl text-tealBrand font-semibold" data-id="element-250">
          6 Tomos + 6 Bonos · 300+ páginas · Todo resuelto.
        </p>
      </div>

      <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-251">
        <span className="text-3xl" data-id="element-252">💪</span> 6 TOMOS COMPLETOS
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-253">
        {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-petroleo rounded-2xl p-8 border border-tealBrand/20 relative overflow-hidden group hover:border-tealBrand/50 transition-colors" data-id="element-254">
            <div className="absolute -right-4 -top-4 text-8xl opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-255">
              {tomo.color}
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-256">
              <span className="text-2xl" data-id="element-257">{tomo.color}</span>
              <h4 className="text-lg font-bold text-white leading-tight" data-id="element-258">
                TOMO {tomo.num} —<br data-id="element-259" />
                <span className="text-amarillo" data-id="element-260">{tomo.title}</span>
              </h4>
            </div>
            <p className="text-gray-300 relative z-10 leading-relaxed" data-id="element-261">
              {tomo.desc}
            </p>
          </motion.div>)}
      </div>

      <div className="bg-nocheLight rounded-2xl p-8 border border-petroleoLight max-w-3xl mx-auto" data-id="element-262">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-263">
          {features.map((feat, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-264">
              <CheckCircle2 className="w-5 h-5 text-tealBrand shrink-0" data-id="element-265" />
              <span className="text-gray-200 font-medium" data-id="element-266">{feat}</span>
            </div>)}
        </div>
      </div>
    </section>;
}